/**
 * 一个成员的头像。传过图就渲染图，没传就是原来那个渐变圆圈 + 名字首字。
 *
 * 抽成组件而不是各处内联：在此之前那个圆圈在 TopBar 里抄了两遍、Layout 的人员
 * sheet 里第三遍，而头像要出现在**五个**地方（再加 /people 列表、看板排行榜、
 * 公开分享页）。八份内联副本里改一个尺寸，必然漏掉几份。
 *
 * `object-cover` 是刻意的：不做裁剪 UI，竖构图的照片由 CSS 居中裁成圆形，
 * 在 28px 和 64px 上都成立。真要让人自己框，那是另一个功能。
 */
export default function Avatar({ name, url, size = 28, className = '' }: {
  name?: string | null
  url?: string | null
  /** 直径，px。顶栏与 sheet 用 28，/people 用 36，排行榜 32，公开页 64。 */
  size?: number
  className?: string
}) {
  // 字号跟着直径走，不然 64px 的圆圈里是个 13px 的小字。0.46 是从既有的
  // 28px/13px 反解出来的比例，所以现有三处的观感不变。
  const style = { width: size, height: size, fontSize: Math.round(size * 0.46) }

  if (url) {
    return (
      <img
        src={url}
        // 名字已经紧挨着渲染（顶栏、sheet、列表、排行榜都是「头像 + 人名」），
        // 再读一遍是重复信息，所以是装饰性的空 alt。
        alt=""
        style={{ width: size, height: size }}
        // block 而不是默认的 inline：公开页用 mx-auto 居中，inline 的 img 上
        // margin:auto 不生效。flex / grid 里的子项本来就会被 blockify，不受影响。
        className={`block shrink-0 rounded-full object-cover bg-sunk ${className}`}
      />
    )
  }

  return (
    <span
      style={style}
      className={
        'shrink-0 rounded-full grid place-items-center font-bold text-white ' +
        `bg-gradient-to-br from-brand to-brand2 ${className}`
      }
    >
      {name?.[0] ?? '?'}
    </span>
  )
}
